import { DateService } from "../../../service/DateService";
import { IReportingPeriod } from "../../../model/reporting/ReportingPeriod";

export interface TReportingPeriodPresentationModel {
  id: number;
  reportingTypeCode: string;
  name: string;
  valid: boolean;
  numberOfReportingPeriod: number;
  status: string;
  periodFrom?: string;
  periodTo?: string;
  tag?: string;
  inputAvailableFrom?: string;
  inputAvailableTo?: string;
  reportingPeriodId: number;
}

const ReportingPeriodPresentationModel = (
  data: IReportingPeriod
): TReportingPeriodPresentationModel => {
  const periodFrom = data.periodFrom
    ? DateService().formatDate(data.periodFrom)
    : undefined;
  const periodTo = data.periodTo
    ? DateService().formatDate(data.periodTo)
    : undefined;
  const inputAvailableFrom = data.inputAvailableFrom
    ? DateService().formatDate(data.inputAvailableFrom)
    : undefined;
  const inputAvailableTo = data.inputAvailableTo
    ? DateService().formatDate(data.inputAvailableTo)
    : undefined;
  return {
    id: data.id,
    reportingTypeCode: data.reportingTypeCode,
    name: data.name,
    valid: data.valid,
    numberOfReportingPeriod: data.numberOfReportingPeriod,
    status: data.status,
    periodFrom,
    periodTo,
    tag: data.tag,
    inputAvailableFrom,
    inputAvailableTo,
    reportingPeriodId: data.reportingPeriodId
  };
};

export default ReportingPeriodPresentationModel;
